import About from './About.js';

export default About;
